// Shared FormData builder for the dynamic-token thunks (POST/PATCH) and
// postData/getData. Centralised so a fix (like array support below) only
// needs to happen once instead of in four near-identical copies.
//
// Array values append every item under the same field name (e.g.
// `FormDataDynamic.Image = [file1, file2]` -> two "Image" entries), matching
// the multi-file-under-one-key convention several upload forms already rely
// on. A caller that needs an indexed key per item instead (e.g.
// `Field[0]`, `Field[1]`) should build those as separate top-level keys in
// FormDataDynamic rather than relying on this helper.
export function buildFormData(FormDataDynamic) {
  const formData = new FormData();
  Object.keys(FormDataDynamic).forEach((key) => {
    const value = FormDataDynamic[key];
    if (Array.isArray(value)) {
      value.forEach((item) => formData.append(key, item));
    } else {
      formData.append(key, value);
    }
  });
  return formData;
}
